<template>  
    <v-card
        height="100%"
        style="width: 100%;"
        class="d-flex flex-wrap align-center justify-center flex-column"
    >
        <div
            class="center"
            style="display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            width: 68px;
            height: 68px;
            border: 4px solid #ccc;
            border-radius: 50%;
            font-size: 36px;"
        >
            <v-icon
                style="display: inline-block;
                font: normal normal normal 14px/1 FontAwesome;
                font-size: inherit;
                text-rendering: auto;
                -webkit-font-smoothing: antialiased;
                "
            >
                mdi-lock
            </v-icon>
        </div>
    
        <v-card-title
            class="center"
        >
            抱歉，此頁面目前暫時無開放給您！
        </v-card-title>

        <v-card-subtitle class="text">
            若您仍需進入此頁面，請聯繫您的組織管理員索取權限。
        </v-card-subtitle>

        <v-btn
            @click="goBackHome"
            class="btn-primary"
            style="color: #fff;"
        >
            回首頁
        </v-btn>

    </v-card>
</template>

<script>
export default {
    name: "Forbidden",
    components: {

    },
    data() {
        return {

        }
    },
    methods: {
        goBackHome() {
            if (this.$route.params.container_id) {
                this.$router.push(`/${this.$route.params.org_id}/${this.$route.params.container_id}/home`)
            }
            else {
                this.$router.push(`/${this.$route.params.org_id}/home`)
            }
        }
    }
}
</script>

<style scoped>
    .wrapper{
        min-height: 100%;
        height: auto !important;
        margin: 0 auto -235px;
        text-align: center;
        padding: 0px 30px;
        font-family: "Source Sans Pro","Open Sans","Helvetica Neue", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
    }
    .title{
        font-size: 700% !important;;
        font-weight: 900;
        color: rgba(0,0,0,0.3);
        line-height: 100px;
        margin-bottom: 15px;
        padding-top: 80px;
        letter-spacing: -1px;
    }
    .engtext{
        font-size: 140%;
        font-weight: 800;
        color: rgba(0,0,0,0.7);
        line-height: 50px;
    }
    .chitext{
        font-size: 140%;
        font-weight: 800;
        color: rgba(0,0,0,0.7);
        line-height: 30px;
        margin-bottom: 30px;
    }
</style>